/**
 * The one status chip (Nov 4 2026: strategy rows, positions and transactions each had their own). A neutral chip whose
 * dot carries the state (John, Oct 31 2026: the chip itself stays neutral): green running, amber in flight or waiting,
 * grey resting, a faded green once done (John, Nov 1 2026: not the same green as live), red stopped or failed.
 */
export type StatusTone = 'live' | 'waiting' | 'resting' | 'done' | 'bad'

const DOT: Record<StatusTone, string> = {
  live: 'bg-accent',
  waiting: 'bg-warning',
  resting: 'bg-muted',
  done: 'bg-accent/35',
  bad: 'bg-negative',
}

const TEXT: Record<StatusTone, string> = {
  live: 'text-text',
  waiting: 'text-muted',
  resting: 'text-muted',
  done: 'text-text',
  bad: 'text-negative',
}

export function StatusChip({ tone, children }: { tone: StatusTone; children: React.ReactNode }) {
  return (
    <span className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border border-line bg-surface-2 px-2.5 py-1 text-xs font-medium leading-none ${TEXT[tone]}`}>
      <span className={`size-1.5 shrink-0 rounded-full ${DOT[tone]}`} aria-hidden="true" />
      {children}
    </span>
  )
}
